export const SET_HAS_MORTGAGE_DISCLAIMER = 'adBanner/SET_HAS_MORTGAGE_DISCLAIMER';

export interface ISetHasMortgageDisclaimerAction {
  type: typeof SET_HAS_MORTGAGE_DISCLAIMER;
  payload: boolean;
}

export const setHasMortgageDisclaimer = (payload: boolean): ISetHasMortgageDisclaimerAction => ({
  type: SET_HAS_MORTGAGE_DISCLAIMER,
  payload,
});

export type TAdBannerActions = ISetHasMortgageDisclaimerAction;
